import { enableProdMode } from '@angular/core';

import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

// Google Analytics (gtag.js)
if (environment.googleAnalyticsId) {
  document.head.appendChild(document.createComment(' Google tag (gtag.js) '));

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`;
  document.head.appendChild(gtagScript);

  const inlineScript = document.createElement('script');
  inlineScript.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${environment.googleAnalyticsId}');
  `;
  document.head.appendChild(inlineScript);
}

// Clarity
if (environment.clarityId) {
  const clarityScript = document.createElement('script');
  clarityScript.async = true;
  clarityScript.type = 'text/javascript';
  clarityScript.text = `
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${environment.clarityId}");
  `;
  document.head.appendChild(clarityScript);
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
